import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Container } from './styled';
import VSRecord from './VSRecord';
import RecentRecord from './RecentMatch';
import NextMatch from './NextMatch';
import TeamRanking from './TeamRanking';
import HockeyStatStore from './store';
import HockeyTeamStat from './TeamStat';
import Seo from '../../../../../components/seo';

const HockeyRecord = ({ gameData }) => {
  let { id } = useParams();
  const { getAll, data } = HockeyStatStore();

  useEffect(() => {
    getAll(id);
  }, []);
  const { loading } = data;
  return (
    <Container>
      <Seo title={`스포츠 아이스하키 상세 전력`} />
      {data.record.vsRecord.length > 0 && (
        <VSRecord data={data.record.vsRecord} />
      )}
      {!loading && (
        <>
          <RecentRecord data={data.record} gameData={gameData} />
          <NextMatch gameData={gameData} data={data.record} />
          <HockeyTeamStat data={data.teamStat} />
          <TeamRanking data={data.rank} />
        </>
      )}
    </Container>
  );
};

export default HockeyRecord;
